// extracted by mini-css-extract-plugin
export var container = "_ip-0";
export var content = "_ip-3";
export var customerTitle = "_ip-4";
export var empty = "_ip-5";
export var gray = "_ip-6";
export var header = "_ip-7";
export var info = "_ip-8";
export var loading = "_ip-2";
export var loadingCard = "_ip-9";
export var oneLine = "_ip-a";
export var personName = "_ip-e";
export var pillContainer = "_ip-b";
export var selected = "_ip-1";
export var text = "_ip-c";
export var twoLines = "_ip-d";
export var unread = "_ip-f";
export var unreadIndicator = "_ip-g";